import { STATUS_TEXT } from './constants'

export const multiSiteTemplate = (onSitesCount, totalSitesCount) =>
  `${STATUS_TEXT} <span>__On__ for ${onSitesCount} out of ${totalSitesCount} Schools</span>`

export const singleSiteTemplate = isUnitOn =>
  `${STATUS_TEXT} <span>__${isUnitOn ? 'On' : 'Off'}__</span>`
